/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDocumentLinkDto } from '../models/work-create-document-link-dto';
import { WorkTenantDocumentLink } from '../models/work-tenant-document-link';
import { WorkUpdateDocumentLinkDto } from '../models/work-update-document-link-dto';

@Injectable({ providedIn: 'root' })
export class WorkTenantsDocumentLinksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentLinksV2ControllerFindDocumentLinks()` */
  static readonly DocumentLinksV2ControllerFindDocumentLinksPath = '/v1/v2/tenants/document-links';

  /**
   * Findet Document-Links basierend auf Filtern.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerFindDocumentLinks()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerFindDocumentLinks$Response(
    params?: {

    /**
     * Filter nach Tenant-ID
     */
      tenantId?: number;

    /**
     * Filter nach lokalem Dokument-ID
     */
      localDocumentId?: number;

    /**
     * Filter nach externem Dokument-ID
     */
      externalDocumentId?: number;

    /**
     * Filter nach Projekt-Link-ID
     */
      projectLinkId?: number;

    /**
     * Filter nach Sync-Status
     */
      syncStatus?: 'pending' | 'syncing' | 'synced' | 'failed' | 'conflict';
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantDocumentLink>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerFindDocumentLinksPath, 'get');
    if (params) {
      rb.query('tenantId', params.tenantId, {});
      rb.query('localDocumentId', params.localDocumentId, {});
      rb.query('externalDocumentId', params.externalDocumentId, {});
      rb.query('projectLinkId', params.projectLinkId, {});
      rb.query('syncStatus', params.syncStatus, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantDocumentLink>>;
      })
    );
  }

  /**
   * Findet Document-Links basierend auf Filtern.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerFindDocumentLinks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerFindDocumentLinks(
    params?: {

    /**
     * Filter nach Tenant-ID
     */
      tenantId?: number;

    /**
     * Filter nach lokalem Dokument-ID
     */
      localDocumentId?: number;

    /**
     * Filter nach externem Dokument-ID
     */
      externalDocumentId?: number;

    /**
     * Filter nach Projekt-Link-ID
     */
      projectLinkId?: number;

    /**
     * Filter nach Sync-Status
     */
      syncStatus?: 'pending' | 'syncing' | 'synced' | 'failed' | 'conflict';
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantDocumentLink>> {
    return this.documentLinksV2ControllerFindDocumentLinks$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantDocumentLink>>): Array<WorkTenantDocumentLink> => r.body)
    );
  }

  /** Path part for operation `documentLinksV2ControllerCreateDocumentLink()` */
  static readonly DocumentLinksV2ControllerCreateDocumentLinkPath = '/v1/v2/tenants/document-links';

  /**
   * Erstellt einen neuen Document-Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerCreateDocumentLink()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentLinksV2ControllerCreateDocumentLink$Response(
    params: {
      body: WorkCreateDocumentLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantDocumentLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerCreateDocumentLinkPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantDocumentLink>;
      })
    );
  }

  /**
   * Erstellt einen neuen Document-Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerCreateDocumentLink$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentLinksV2ControllerCreateDocumentLink(
    params: {
      body: WorkCreateDocumentLinkDto
    },
    context?: HttpContext
  ): Observable<WorkTenantDocumentLink> {
    return this.documentLinksV2ControllerCreateDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantDocumentLink>): WorkTenantDocumentLink => r.body)
    );
  }

  /** Path part for operation `documentLinksV2ControllerGetDocumentLink()` */
  static readonly DocumentLinksV2ControllerGetDocumentLinkPath = '/v1/v2/tenants/document-links/{id}';

  /**
   * Holt einen Document-Link anhand der ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerGetDocumentLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerGetDocumentLink$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantDocumentLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerGetDocumentLinkPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantDocumentLink>;
      })
    );
  }

  /**
   * Holt einen Document-Link anhand der ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerGetDocumentLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerGetDocumentLink(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTenantDocumentLink> {
    return this.documentLinksV2ControllerGetDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantDocumentLink>): WorkTenantDocumentLink => r.body)
    );
  }

  /** Path part for operation `documentLinksV2ControllerDeleteDocumentLink()` */
  static readonly DocumentLinksV2ControllerDeleteDocumentLinkPath = '/v1/v2/tenants/document-links/{id}';

  /**
   * Löscht einen Document-Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerDeleteDocumentLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerDeleteDocumentLink$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerDeleteDocumentLinkPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Löscht einen Document-Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerDeleteDocumentLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerDeleteDocumentLink(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentLinksV2ControllerDeleteDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentLinksV2ControllerUpdateDocumentLink()` */
  static readonly DocumentLinksV2ControllerUpdateDocumentLinkPath = '/v1/v2/tenants/document-links/{id}';

  /**
   * Aktualisiert einen Document-Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerUpdateDocumentLink()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentLinksV2ControllerUpdateDocumentLink$Response(
    params: {
      id: number;
      body: WorkUpdateDocumentLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantDocumentLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerUpdateDocumentLinkPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantDocumentLink>;
      })
    );
  }

  /**
   * Aktualisiert einen Document-Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerUpdateDocumentLink$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentLinksV2ControllerUpdateDocumentLink(
    params: {
      id: number;
      body: WorkUpdateDocumentLinkDto
    },
    context?: HttpContext
  ): Observable<WorkTenantDocumentLink> {
    return this.documentLinksV2ControllerUpdateDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantDocumentLink>): WorkTenantDocumentLink => r.body)
    );
  }

  /** Path part for operation `documentLinksV2ControllerTriggerSync()` */
  static readonly DocumentLinksV2ControllerTriggerSyncPath = '/v1/v2/tenants/document-links/{id}/sync';

  /**
   * Triggert die Synchronisation eines Document-Links.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerTriggerSync()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerTriggerSync$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerTriggerSyncPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Triggert die Synchronisation eines Document-Links.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerTriggerSync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerTriggerSync(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentLinksV2ControllerTriggerSync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentLinksV2ControllerSyncAllDocumentsForProject()` */
  static readonly DocumentLinksV2ControllerSyncAllDocumentsForProjectPath = '/v1/v2/tenants/document-links/project/{projectLinkId}/sync-all';

  /**
   * Synchronisiert alle Dokumente für einen Projekt-Link.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerSyncAllDocumentsForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerSyncAllDocumentsForProject$Response(
    params: {
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerSyncAllDocumentsForProjectPath, 'post');
    if (params) {
      rb.path('projectLinkId', params.projectLinkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Synchronisiert alle Dokumente für einen Projekt-Link.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerSyncAllDocumentsForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerSyncAllDocumentsForProject(
    params: {
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentLinksV2ControllerSyncAllDocumentsForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentLinksV2ControllerInitialSyncForTenant()` */
  static readonly DocumentLinksV2ControllerInitialSyncForTenantPath = '/v1/v2/tenants/document-links/tenant/{tenantId}/initial-sync';

  /**
   * Initialer Sync: Erstellt Document-Links für alle bestehenden Dokumente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLinksV2ControllerInitialSyncForTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerInitialSyncForTenant$Response(
    params: {
      tenantId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsDocumentLinksService.DocumentLinksV2ControllerInitialSyncForTenantPath, 'post');
    if (params) {
      rb.path('tenantId', params.tenantId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Initialer Sync: Erstellt Document-Links für alle bestehenden Dokumente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLinksV2ControllerInitialSyncForTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLinksV2ControllerInitialSyncForTenant(
    params: {
      tenantId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.documentLinksV2ControllerInitialSyncForTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
